import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'

import leftArrow from '../../../../resources/line_items_details_arrow_left.png'
import rightArrow from '../../../../resources/line_items_details_arrow_right.png'

export default class LineItemsDetailsControlDaySelector extends React.Component {

  static propTypes = {
    dateStr: PropTypes.string.isRequired,
    jobInfo: PropTypes.shape().isRequired,
    onDaySelectorChanged: PropTypes.func.isRequired
  }

  getDayDisplay = () => {
    const date = moment(this.props.dateStr)
    return date.format('MMMM, DD')
  }

  isAllowed = (direction, jobInfo, dateStr) => {
    return direction === 'left' && dateStr !== jobInfo.modules.date.startDate
      || direction === 'right' && dateStr !== jobInfo.modules.date.endDate
  }

  handleSelectorClicked = (event, direction) => {
    event.preventDefault()
    if (this.isAllowed(direction, this.props.jobInfo, this.props.dateStr)) {
      const delta = direction === 'left' ? -1 : +1
      const newDateStr = moment(this.props.dateStr)
        .add('days', delta)
        .format('YYYY-MM-DD')
      this.props.onDaySelectorChanged(newDateStr)
    }
  }

  render() {
    return (
      <div style={styles.container}>
        <img
          style={styles.selector(this.isAllowed('left', this.props.jobInfo, this.props.dateStr))}
          onClick={event => this.handleSelectorClicked(event, 'left')}
          src={leftArrow}
          width={8}
          height={14} />
        <div style={styles.dateDisplay}>
          { this.getDayDisplay() }
        </div>
        <img
          style={styles.selector(this.isAllowed('right', this.props.jobInfo, this.props.dateStr))}
          onClick={event => this.handleSelectorClicked(event, 'right')}
          src={rightArrow}
          width={8}
          height={14} />
      </div>
    )
  }

}

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },

  dateDisplay: {
    marginLeft: 60,
    marginRight: 60
  },

  selector: (allowed) => ({
    cursor: allowed ? 'pointer': 'not-allowed'
  })

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/lineItems/LineItemsDetailsDaySelector.js